import { isLogined } from '../utils/authorized.js'
import utils from '../utils/index.js'
import scTongji from '../utils/track/sc'
// 路由页面路由首位配置
export default (VueRouter, router) => {
  // 解决路由点击重复报错
  const VueRouterPush = VueRouter.prototype.push
  VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
  }
  VueRouter.prototype.replace = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
  }
  const auth = {
    loggedIn: () => {
      return utils.isLogined()
    }
  }
  /*eslint-disable*/
  router.beforeEach((to, from, next) => {
    console.log(to, 'beforeEach')
    if (sessionStorage.getItem('scene')) {
      const sceneParams = {
        name: to.name,
        ...to.query
      }
      sessionStorage.setItem('scene', JSON.stringify(sceneParams))
    }
    let wxCode = sessionStorage.getItem('wxCode') || ''
    const authList = ['worldCup', 'aon', 'aonResult']
    const authState = authList.includes(to.name)
    if (authState && (!wxCode || !to.query.code)) {
      // 世界杯未授权先授权
      const appId = window.location.host.indexOf('provider') > -1 ? 'wx4e55fbf116b4e297' : 'wx69e42477e2584da7'
      let url = `${window.location.origin}/m${to.path}`
      window.location.replace(
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect`
      )
      sessionStorage.setItem('wxCode', 'Y')
    }
    // 目的：表单填写的组件生成路由在浏览器历史记录里，可以实现组件间回退
    if (to.query.s && to.name == 'claimApply') {
      store.commit('common/setClaimStep', to.query.s)
    } else if (!to.query.s && to.name == 'claimApply') {
      store.commit('common/setClaimStep', '1')
    }

    if (to.query.s && to.name == 'preAuthApply') {
      store.commit('common/setStep', to.query.s)
    } else if (!to.query.s && to.name == 'preAuthApply') {
      store.commit('common/setStep', '1')
    }

    if (to.query.e && to.name == 'preAuthApply') {
      store.commit('common/setEdit', to.query.e)
    } else if (!to.query.e && to.name == 'preAuthApply') {
      store.commit('common/setEdit', true)
    }

    if (to.name === 'login' && auth.loggedIn()) {
      next({
        name: 'member'
      })
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!auth.loggedIn() && to.name != 'login') {
        next()
      } else {
        next()
      }
    } else {
      next() // make sure to always call next()!
    }
    scTongji(auth, to, from)
  })
  router.afterEach(to => {})
  /*eslint-disable*/
}
